import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

/**
 * Segna uno o più lead come visti
 * @param {string} uname - Username
 * @param {string} token - Token di autenticazione
 * @param {number|null} leadId - ID singolo del lead (opzionale)
 * @param {number[]|null} leadIds - Array di ID lead (opzionale)
 * @param {boolean} markAll - Se true, segna tutti i lead come visti
 * @returns {Promise<{success: boolean, updated: number, remaining_unread: number}>}
 */
export default async function setLeadVisto(
  uname,
  token,
  leadId = null,
  leadIds = null,
  markAll = false
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "setLeadVisto.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          const resp = JSON.parse(body.toString());
          resolve(resp);
        } catch (e) {
          console.error("setLeadVisto parse error:", e);
          resolve({ success: false });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        resolve({ success: false });
      });
    });

    var postDataObj = {
      token: token,
      uname: uname,
    };

    if (markAll) {
      postDataObj.mark_all = "true";
    } else if (leadId) {
      postDataObj.lead_id = leadId;
    } else if (leadIds && leadIds.length > 0) {
      postDataObj.lead_ids = JSON.stringify(leadIds);
    }

    var postData = qs.stringify(postDataObj);

    req.write(postData);
    req.end();
  });
}
